import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { app_base_url } from "../Utils/baseUrl";
import { SignInCartorio } from "../Pages/Cartorio_Pages/AuthPages/SignInCartorio";
import { SignInFuncionarioCartorio } from "../Pages/Cartorio_Pages/AuthPages/SignInFuncionarioCartorio";
import { FuncionarioCartorioProvider } from "../Hooks/funcionarioCartorio";
import { SignInPrefeitura } from "../Pages/Cartorio_Pages/AuthPages/SignInPrefeitura";
import { Cadastrar } from "../Pages/Cartorio_Pages/AuthPages/Cadastrar";
import { SignFuncionarioPrefeitura } from "../Pages/Cartorio_Pages/AuthPages/SignInFuncionarioPrefeitura";
import { Default } from "../Pages/Cartorio_Pages/AuthPages/Default";

export function AuthRoutes() {
  return (
    <Router>
      <Routes>
        <Route
          path={`${app_base_url}/cartorio/funcionario`}
          element={<SignInFuncionarioCartorio />}
        ></Route>
        <Route
          path={`${app_base_url}/cartorio`}
          element={<SignInCartorio />}
        ></Route>
        <Route
          path={`${app_base_url}/cartorio/cadastrar`}
          element={<Cadastrar />}
        ></Route>
        <Route
          path={`${app_base_url}/prefeitura/funcionario`}
          element={<SignFuncionarioPrefeitura />}
        ></Route>

        <Route
          path={`${app_base_url}/prefeitura`}
          element={<SignInPrefeitura />}
        ></Route>
        <Route path={`${app_base_url}/*`} element={<Default />}></Route>
      </Routes>
    </Router>
  );
}
